export default {
  FLIGHT_REQUEST: "flights/FLIGHT_REQUEST",
  FLIGHT_RESPONSE: "flights/FLIGHT_RESPONSE",
  SET_BOOKINGDATE: "flights/SET_BOOKINGDATE",
  SET_FARE_KEY:"flights/FARE_KEY",
  FLIGHT_SEARCH_RESPONSE: 'flights/FLIGHT_SEARCH_RESPONSE'
};
